import React, {useEffect, useState} from 'react';
import { renderDropdown, renderDropdownReadOnly} from "./DropdownFunctions";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import PropTypes from "prop-types";
import {Globals} from "root/DataFunctions/BaseDataFns";
import {genericListboxFetch} from "root/ReactHookForm/ui/DropdownDataProviders";

const ReactHookFormDropdownLetterboxItemTypes = (props) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        //Gets all users in an org that can recieve letterbox items
        const url = Globals.APIFolder + '/letterbox/types?exclude_message=true' ;

        genericListboxFetch( {url:url, keyFieldName: 'letterbox_item_type_id', labelFieldName: 'letterbox_item_type'}).then((response) =>
        {
            setData ( { loading: false, items: response }) ;
        }) ;
    }, []);

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props.value, props.onChange, data.items, { ...props.options, ... {isSearchable: true}}) : renderDropdown(props.value, props.onChange, data.items, { ...props.options, ... {isSearchable: true}})
    )
}

export default ReactHookFormDropdownLetterboxItemTypes;

ReactHookFormDropdownLetterboxItemTypes.defaultProps =
{
    defaultClassName: ''
}

ReactHookFormDropdownLetterboxItemTypes.propTypes = {
    onChange: PropTypes.func.isRequired
};
